export const isNotNumeric = (value) => !value || Number.isNaN(+value);
export const getCeilNumber = (number, decimal = 10) => (
  isNotNumeric(number) ? 0 : Math.ceil(+number * 10 ** decimal) / 10 ** decimal
);

export const getFloorNumber = (number, decimal = 10) => (
  isNotNumeric(number) || Number.isNaN(+number)
    ? 0
    : Math.floor(+number * 10 ** decimal) / 10 ** decimal);

export const COMMA_SEPARATOR = ',';

export const currencyFormat = ({
  value,
  currency = '',
  isPrefix = false,
  isWithoutSpace = false,
  format = 'floor',
  options,
  // separator,
}) => {
  const displayCurrency = currency || '';

  const space = isWithoutSpace ? '' : ' ';
  const displaySpace = currency ? space : '';

  let formattedValue = +value;

  if (format === 'floor') {
    formattedValue = getFloorNumber(value);
  } else if (format === 'ceil') {
    formattedValue = getCeilNumber(value);
  }

  const number = Intl.NumberFormat(
    'it-IT',
    options || { maximumFractionDigits: 10 },
  ).format(formattedValue);

  const formattedCurrency = isPrefix
    ? displayCurrency + displaySpace + number
    : number + displaySpace + displayCurrency;

  return formattedCurrency;
};

export const formatNumber = (value) => {
  if (value === undefined || value === null) return '';
  const num = +value;
  if (Number.isNaN(num)) return '';
  return new Intl.NumberFormat('vi-VN', {
    maximumFractionDigits: 10,
  }).format(num);
};

export const numberWrapper = (value) => (isNotNumeric(value) ? 0 : +value);

/**
 * Lấy chuỗi chỉ gồm chữ số từ input tiền (bỏ dấu . , khoảng trắng...).
 * Dùng khi onChange để lưu raw value: "3.000.000" -> "3000000"
 */
export const getRawCurrencyDigits = (value = '') => (
  String(value).trim().replace(/[^0-9]/g, '')
);

/**
 * Parse input tiền có format VN về number để gửi API.
 * "3.000.000" / "3000000" -> 3000000
 * "" / null / invalid -> undefined
 */
export const parseCurrencyInputToNumber = (value) => {
  if (value === '' || value === null || value === undefined) return undefined;

  const rawValue = String(value).replace(/\./g, '').replace(',', '.');
  const numberValue = Number(rawValue);

  return Number.isNaN(numberValue) ? undefined : numberValue;
};

/**
 * Format số thành dạng dễ đọc theo VN (dấu chấm ngăn nghìn).
 * 3000000 -> "3.000.000"
 */
export const formatCurrencyDigits = (value) => {
  const numberValue = parseCurrencyInputToNumber(value);

  if (numberValue === undefined) return '';

  return formatNumber(numberValue);
};
